import { useEffect, useRef } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export const useAds = () =>
  useQuery({ queryKey: ["ads"], queryFn: async () => (await api.get("/ads")).data, staleTime: 120000 });

export const trackAd = (adId, type) => api.post("/ads/event", { ad_id: adId, type }).catch(() => {});

export function useImpression(adId) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el || !adId) return;
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) {
        trackAd(adId, "impression");
        obs.disconnect();
      }
    }, { threshold: 0.5 });
    obs.observe(el);
    return () => obs.disconnect();
  }, [adId]);
  return ref;
}

// Positions where a sponsored card appears: after every `every` stories, rotating through cards.
export function sponsoredAt(index, ads) {
  if (!ads?.sponsored_enabled) return undefined;
  const every = ads.sponsored_every || 6;
  if (index === 0 || index % every !== 0) return undefined;
  const slot = index / every - 1;
  return ads.cards?.length ? ads.cards[slot % ads.cards.length] : null;
}

export function getVisitorId() {
  let v = localStorage.getItem("ntn_vid");
  if (!v) {
    v = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now().toString(16)}-${Math.random().toString(16).slice(2, 14)}`);
    localStorage.setItem("ntn_vid", v);
  }
  return v;
}
